// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__IhJY2","container":"styles_container__7aNtv"};